import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { of } from 'rxjs';
import { DataRequest } from 'src/core/actions/conversation/conversation-module.actions';
import { Store } from '@ngxs/store';
import { ConversationImportWizardService } from '../../../conversation-import-wizard.service';
import { ConversationImportFileModel } from 'src/core/models/conversation/conversation-import-file-model';
import { ChatService } from 'src/core/services/conversation/chat.service';
import { ConversationImportStatus } from 'src/core/models/conversation/conversation-import-status.dto';

@Component({
    selector: 'ca-chat-import-step-three',
    templateUrl: './chat-import-step-three.component.html',
    styleUrls: ['./chat-import-step-three.component.scss'],
    standalone: false
})
export class ChatImportStepThree implements OnInit {

  @Input()
  set cancelImport(value: boolean) {
    if (value) {
      this.pauseImporting();
    }
    else {
      this.resumeImporting();
    }
  }
  get cancelImport(): boolean {
    return this.pauseTag;
  }

  @Output()
  progress: EventEmitter<{
    progressValue: number
  }> = new EventEmitter();

  constructor(
    private chatService: ChatService,
    private store: Store,
  ) { }

  formData = new FormData();
  selectedCsvFile: File;
  public selectedConversationFiles: ConversationImportFileModel[] = [];
  public systemLangCode: string;
  processCode: string = Math.round((Math.pow(36, 10 + 1) - Math.random() * Math.pow(36, 10))).toString(36).slice(1);
  chatImportStatus: ConversationImportStatus[] = [];
  public progressValue: number = 0;
  conversationImportWizardService: ConversationImportWizardService;

  private lastIndex: number = 0;
  private pauseTag = false;

  ngOnInit(): void { }

  async bindFormData() {
    this.formData = new FormData();
    this.formData.append('processCode', this.processCode);
    this.formData.append('languageCode', this.systemLangCode);
    if (this.selectedCsvFile) {
      this.formData.append('csvFile', this.selectedCsvFile, this.selectedCsvFile.name);
      try {
        await this.chatService.csvImport(this.formData).toPromise();
      } catch (error) {
        return false;
      }
      this.formData.delete('csvFile');
    }
    return true;
  }

  async validateEntryToStep() {
    if (!await this.bindFormData()) {
      return;
    }

    for (const data of this.selectedConversationFiles) {
      var status = new ConversationImportStatus();
      status.fileName = data.file.name;
      this.chatImportStatus.push(status);
    }

    this.startImporting();

    return true;
  }

  validateExitFromStep() {
    return of(false);
  }

  async startImporting(startIndex: number = 0) {
    for (let i = startIndex; i < this.selectedConversationFiles.length; i++) {
      if (this.pauseTag) {
        this.lastIndex = i;
        return false;
      }
      else {
        var data = this.selectedConversationFiles[i];
        const file = data.file;
        this.formData.delete('File');
        this.formData.append('File', file, file.name);
        var status = this.chatImportStatus[i];

        try {
          this.chatImportStatus[i] = await this.chatService.import(this.formData).toPromise();;
        } catch (error) {
          status.error = error.error.error.message;
          status.success = false;
          status.fileName = file.name;
          this.chatImportStatus[i] = status;
        }

        this.progressValue = 100 * (i + 1) / this.selectedConversationFiles.length;
        this.progress.emit({ progressValue: this.progressValue });

        if (this.progressValue === 100 && status.success) {
          const dataRequestAction = new DataRequest();
          this.store.dispatch(dataRequestAction);
        }
      }
    }
    return true;
  }

  pauseImporting(): void {
    this.pauseTag = true;
  }

  resumeImporting(): void {
    this.pauseTag = false;
    this.startImporting(this.lastIndex);
  }
}